import React from 'react';
import Lottery from '../v2/components/lottery';
import HomeScratch from '../v2/components/home-scratch';
import AnnaHomeLive from './anna-home-live';
import AnnaHomeGames from './anna-home-games';
import '../v2/index.css';

interface AnnaHomeContentProps {
  activeIndex: number;
  scrollViewRef?: React.RefObject<any>;
  scrollY?: number;
}

const AnnaHomeContent = ({
  activeIndex,
  scrollViewRef,
  scrollY,
}: AnnaHomeContentProps) => {
  return (
    <div className="bg-light-grey">
      {activeIndex === 0 && (
        <div className="anna-home-lottery">
          <Lottery scrollViewRef={scrollViewRef} scrollY={scrollY} />
        </div>
      )}
      {activeIndex === 1 && <HomeScratch />}
      {activeIndex === 2 && <AnnaHomeGames />}
      {activeIndex === 3 && <AnnaHomeLive />}
    </div>
  );
};

export default AnnaHomeContent;
